import { format, parse, isValid } from "date-fns";

export type FormatMode = "full" | "dateOnly" | "timeOnly";

export interface UserPreferences {
  dateFormat?: string;
  timeFormat?: string;
}

export const getUserDateFormatPattern = (preferences?: UserPreferences): string =>
  preferences?.dateFormat === "MM_DD_YYYY" ? "MM/dd/yyyy" : "dd/MM/yyyy";

export const getUserTimeFormatPattern = (preferences?: UserPreferences): string =>
  preferences?.timeFormat === "12_HOUR" ? "hh:mm a" : "HH:mm";

export const getUserDateTimeFormatPattern = (preferences?: UserPreferences): string =>
  `${getUserDateFormatPattern(preferences)} ${getUserTimeFormatPattern(preferences)}`;

export const formatDateWithUserPref = (
  value: any,
  preferences: UserPreferences,
  mode: FormatMode = "full"
): string => {
  if (!value) return "";

  const preferredDateFormat = getUserDateFormatPattern(preferences);
  const preferredTimeFormat = getUserTimeFormatPattern(preferences);

  let finalPattern = "";
  switch (mode) {
    case "dateOnly":
      finalPattern = preferredDateFormat;
      break;
    case "timeOnly":
      finalPattern = preferredTimeFormat;
      break;
    default:
      finalPattern = `${preferredDateFormat} ${preferredTimeFormat}`;
  }

  let date = new Date(value);

  if (!isValid(date) && typeof value === "string") {
    date = parse(value.toLowerCase(), "dd/MM/yyyy hh:mmaaa", new Date());
  }

  return isValid(date) ? format(date, finalPattern) : value;
};
